import { Box, styled, Typography } from '@mui/material';

export const PdfCard = styled(Box)(({ theme }) => ({
    borderRadius: theme.typography.customFontSize.xSmall, // 12px
    background: theme.palette.background.paper,

    border: `1px solid ${theme.palette.border.neutralPrimary}`,
    margin: theme.typography.generic.xSmall,
    width: '12.5rem',
    cursor: 'pointer',

    [theme.breakpoints.down('sm')]: {
        width: '10rem',
    },
}));
export const IconsBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'start',
    marginBottom: theme.typography.generic.xLarge,
    padding: theme.typography.generic.xLarge,
    cursor: 'pointer',

    [theme.breakpoints.down('sm')]: {
        padding: theme.typography.generic.medium,
    },
}));

// Corporate docs

export const PdfPara = styled(Typography)(({ theme }) => ({
    color: theme.palette.gray[700],
    fontSize: theme.typography.customFontSize.xSmall, // 12px
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: 1.4,

    [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.customFontSize.xxSmall, // 10px
    },
}));
export const PdfHeader = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    fontSize: theme.typography.customFontSize.small, // 14px
    fontWeight: theme.typography.fontWeightSemiBold, //600
    lineHeight: 1.4,

    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',

    [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.customFontSize.xSmall, // 12px
    },
}));
